<template>
  <step-wrapper space-between>
    <div class="wrapper">
      <copy-section
        :heading="copy.heading"
        :description="copy.description"
      />
      <div class="description">
        <p class="description__inner">
          Wszystkie propozycje, które przejdą pomyślnie weryfikację, trafią na naszą mapę.<br>
          Dodatkowo, wsród najciekawszych zgloszeń rozlosujemy Królewskie upomniki.<br>
          Powodzenia!
        </p>
      </div>
    </div>
    <content-wrapper type="huge" center>
      <div class="buttons-wrapper">
        <button-component
          class="again-button"
          @click="goToFirstStep"
        >
          Dodaj kolejny
        </button-component>
        <button-component @click="gotToMap">Wróć do mapy</button-component>
      </div>
    </content-wrapper>
  </step-wrapper>
</template>

<script>
import store from '@/store'
import {mapMutations} from 'vuex'
import {UNSET_ADD_PLACE_SUCCESS} from '@/store/mutation-types'
import StepWrapper from '@/components/StepWrapper'
import ContentWrapper from '@/components/ContentWrapper'
import CopySection from '@/components/CopySection'
import RulesPrizesContainer from '@/containers/ContestPrizes'
import ButtonComponent from '@/components/Button'

export default {
  components: {
    StepWrapper,
    CopySection,
    ContentWrapper,
    RulesPrizesContainer,
    ButtonComponent
  },
  data () {
    return {
      copy: {
        heading: 'Dziękujemy',
        description: `
          Za współtworzenie z nami <br>
          <strong>oficjalnej mapy nieoficjalnej Warszawy</strong>
        `
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (store.state.add.success) {
      next()
    } else {
      next({ name: 'contest' })
    }
  },
  beforeDestroy () {
    this.unsetAddPlaceSuccess()
  },
  methods: {
    ...mapMutations({
      unsetAddPlaceSuccess: UNSET_ADD_PLACE_SUCCESS
    }),
    goToFirstStep () {
      this.$router.push({ name: 'add-step-1' })
    },
    gotToMap () {
      this.$router.push({ name: 'map' })
    }
  }
}
</script>

<style lang="scss" scoped>
  // TODO: create button wrapper component
  .buttons-wrapper {
    button {
      margin: 0 20px;

      @include media-down(md) {
        width: 100%;
        margin: 20px 0;
      }
    }
  }

  .wrapper {
    width: 100%;
  }

  .again-button {
    @include hide-down(md)
  }

  .description {
    @include font($akrobat-font, 300);

    padding-left: $container-margin;
    padding-right: $container-margin;
    margin: 20px auto;
    max-width: 500px;
    width: 100%;

    @include media-up(xl) {
      max-width: 720px !important;
    }

    &__inner {
      font-size: 16px;
      line-height: 21px;
      font-weight: 300;

      @include media-up(xl) {
        line-height: 24px;
        font-size: 24px;
      }
    }

    &__heading {
      margin: 0 0 .1em;
      font-weight: 900;
      font-size: 38px;

      @include media-up(xl) {
        font-size: 56px;
      }
    }

    &__content {
      margin: 0;
      font-size: 20px;
      position: relative;

      /deep/ strong {
        font-weight: 700;
        display: block;

        @include media-up(sm) {
          display: inline;
        }
      }

      @include media-up(xl) {
        font-size: 24px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/AddPlace/AddPlaceConfirmation.vue